import { Button, Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

import { ReactComponent as FormInfo } from '@/assets/icons/form-info-icon.svg';

export const InfoTooltip = styled(({ className, ...props }: Omit<TooltipProps, 'children'>) => (
  <Tooltip {...props} classes={{ popper: className }}>
    <span>
      <Button type="button" sx={{ minWidth: 0, padding: '0.25rem' }} disableRipple>
        <FormInfo />
      </Button>
    </span>
  </Tooltip>
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: '25rem',
  },
});
